import React, { useState, useEffect } from 'react';
// eslint-disable-next-line import/order
import ContentModelField from './ContentModelField';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import arrayMove from 'array-move';
// eslint-disable-next-line import/order
import draggableIcon from '../../asset/draggable.png';
import './contentModelDetail.css';
import { useDispatch, useSelector } from 'react-redux';
import { setCustomTypeDraft } from '../../actions/CustomTypeAction';

const DragHandle = SortableHandle(() => (
  <img alt="Logo" src={draggableIcon} style={{ color: '#999', cursor: 'grab' }} />
));

const SortableItem = SortableElement(({ index, field, setDeletedFieldInfo }) => {
  return (
    <ContentModelField
      DragHandle={DragHandle}
      field={field}
      index={index}
      setDeletedFieldInfo={setDeletedFieldInfo}
    />
  );
});

const SortableList = SortableContainer(({ items, setDeletedFieldInfo }) => {
  return (
    <div className="content-model-container">
      {items
        ?.sort((a, b) => a.order - b.order)
        .map((value, index) => (
          <SortableItem
            key={value.key}
            field={value.field}
            index={index}
            setDeletedFieldInfo={setDeletedFieldInfo}
          />
        ))}
    </div>
  );
});

const ContentModelFields = ({ setDeletedFieldInfo }) => {
  const dispatch = useDispatch();
  const customTypeDraft = useSelector(({ customType }) => customType.customTypeDraft);

  const data = Object.keys(customTypeDraft.template).map((key, index) => {
    const item = customTypeDraft.template[key];

    return {
      field: item,
      index,
      key: item.field_name,
      name: key,
      order: item.order
    };
  });

  const onSortStartHandler = () => {
    const container = document.querySelector('.content-model-container');
    container.classList.add('container-dragged');
  };

  const [dataSource, setDataSource] = useState(data);

  useEffect(() => {
    setDataSource(data);
  }, [customTypeDraft]);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const customTemplate = customTypeDraft.template;
      const newData = arrayMove(dataSource, oldIndex, newIndex);

      newData.forEach((item, index) => {
        newData[index].order = index;
      });

      Object.keys(customTypeDraft.template).forEach((key) => {
        const selectedItem = newData.find((item) => item.name === key);
        customTemplate[key].order = selectedItem.order;
      });

      setDataSource(newData);

      dispatch(
        setCustomTypeDraft({
          ...customTypeDraft,
          template: customTemplate
        })
      );
    }

    const container = document.querySelector('.content-model-container');
    container.classList.remove('container-dragged');
  };

  return (
    <div
      style={{
        background: 'white',
        paddingBottom: '64px',
        paddingTop: '16px'
      }}
    >
      <SortableList
        helperClass="content-model-dragging"
        items={dataSource}
        onSortEnd={onSortEnd}
        onSortStart={onSortStartHandler}
        setDeletedFieldInfo={setDeletedFieldInfo}
        useDragHandle
      />
    </div>
  );
};

export default ContentModelFields;
